import type { FaireProductEntity } from "../../entity_types/product";

export const p_ud6gvh54sd: FaireProductEntity = {
  token: "p_ud6gvh54sd",
  type: "product",
  name: "CASA POLANCO",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/6fc13c3249327727f6d801a7d8f82a30b7fe11c2ada9ed22345ebfe6ebe8f601.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e415dafdedc4181f6fb8402b0f37cc77d0148b2337c3f37fd277a589d7883441.jpeg",
    "https://cdn.faire.com/fastly/8b34e36f38c512aa06312b3a350e39af3ace122b13aa84e7e9037576df4cafb9.jpeg",
    "https://cdn.faire.com/fastly/231421a192de0a71c09392692310cc4b1db02ca15f52f8e9664c80bbc4caeeb5.jpeg",
  ],
  priceDollars: 19,
  description:
    "A refuge among urban bustle sits the elegantly renovated art art nouveau mansion, Casa Polanco. Ivy covered Juliette balconies, soaring arched doorways, pristine white walls and cool marble floors. A tranquil retreat hidden behind a leafy wrought iron gate, breathe in the clean scent of fresh linens and lush greenery from the neighboring parque.\n\nVerbena leaf, key limes, violet absolute, clove basil and frankincense.\n\nIllustrations by fellow dreamer Freddy Terriquez; when he's not packing candles he's sketching some of our favorite designs.\n\nThese beautiful hand-painted jars are designed to be re-loved and reused.\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8 ounces (226g), comes in our signature Mexico City box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:39.624Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
